export const mediaConstants = {
    GET_PICTURES_REQUEST: 'MEDIA/GET_PICTURES_REQUEST',
    GET_PICTURES_SUCCESS: 'MEDIA/GET_PICTURES_SUCCESS',
    GET_PICTURES_FAILURE: 'MEDIA/GET_PICTURES_FAILURE',

    GET_LINKS_REQUEST: 'MEDIA/GET_LINKS_REQUEST',
    GET_LINKS_SUCCESS: 'MEDIA/GET_LINKS_SUCCESS',
    GET_LINKS_FAILURE: 'MEDIA/GET_LINKS_FAILURE',

    GET_DOCUMENTS_REQUEST: 'MEDIA/GET_DOCUMENTS_REQUEST',
    GET_DOCUMENTS_SUCCESS: 'MEDIA/GET_DOCUMENTS_SUCCESS',
    GET_DOCUMENTS_FAILURE: 'MEDIA/GET_DOCUMENTS_FAILURE',
}
